import React, { useState, useEffect } from 'react'
import DashboardBlock from './dashboardwidgetsblock';


export default function RaisedViolation({ totalRaisedCount, totalRaisedAmount,loading }) {
    const [amount, setAmount] = useState(totalRaisedAmount);
    const [raisedcases, setRaisedCases] = useState(0);
    
    useEffect(() => {
        setRaisedCases(totalRaisedCount);
        setAmount(totalRaisedAmount);
    }, [totalRaisedCount, totalRaisedAmount])

    return (
        <DashboardBlock
            classname="violence-block"
            title="Total Raised Violations"
            titlecolor={"#707070"}
            count={raisedcases}
            countcolor="#303A78"
            font_size="50px"
            showpercent={false}
            amount={amount}
            amount_color="#707070"
            loader={loading} />
    )
}
